import { get, writable } from 'svelte/store';

const STORAGE_KEY = 'shelly_dev_nav_scroll_compact';

const readInitialValue = (): boolean => {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		// Default off: keep the dock at full size while scrolling (experiment).
		if (stored === null) return false;
		return stored === 'true';
	} catch {
		return false;
	}
};

/**
 * When true, the floating dock shrinks on downward scroll (`compact` prop).
 * When false, the dock stays large. Preference is saved locally.
 */
export const navScrollCompactEnabled = writable<boolean>(readInitialValue());

navScrollCompactEnabled.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const isNavScrollCompactEnabled = (): boolean => get(navScrollCompactEnabled);

export const setNavScrollCompactEnabled = (enabled: boolean) => {
	navScrollCompactEnabled.set(enabled);
};
